/*@ngInject*/
const SectionTemplateEditorHeaderController = function ($rootScope, $scope, $element, $stateParams, $state, coreConstant, localization, sectionTemplateEditorModel, configurationMediator, sectionTemplateAction, modalUtil, configurationActionsUtil, configurationConstant, sectionTemplateActionsUtil, loadingBarHandler, sectionTemplateApplicabilityType) {

    $element.addClass('sectionTemplateEditorHeader');

    this.sectionTemplate = null;
    this.translations = null;

    this.actions = [];
    this.context = {
        identifier: 'sectionTemplateEditorHeader',
        actions: {},
        fallthrough: null,
        model: {
            contextType: coreConstant.CONTEXT_NONE
        }
    };
    this.context.actions[coreConstant.CONTEXT_NONE] = '';
    this.actionSubTexts = {};

    this.$onInit = function () {
        localization.getTranslationByKey('sectionTemplateEditorHeader').then((translations) => {
            this.sectionTemplate = sectionTemplateEditorModel.getSectionTemplate(parseInt($stateParams.sectionTemplateId));
            this.translations = translations;
            this.loadActions();
        });
    };

    this.loadActions = function () {
        configurationMediator.loadSectionTemplateActions($stateParams.sectionTemplateId).then((actions) => {
            let allActions = [];
            allActions.push({
                actions: actions.actions,
                contextType: this.context.model.contextType
            });

            this.processActions(allActions);
        });
    };

    this.processActions = function (actions) {
        this.actions = actions;
        this.actionSubTexts = {};

        _.each(this.actions, (subAction) => {
            _.each(subAction.actions, (action) => {
                if (action.name === sectionTemplateAction.SAVE) {
                    action.enabled = false;
                    if (sectionTemplateEditorModel.hasUnsavedPropertiesChanges($stateParams.sectionTemplateId) ||
                        sectionTemplateEditorModel.hasUnsavedRuleChanges($stateParams.sectionTemplateId)) {
                        this.actionSubTexts[action.name] = {
                            class: 'unsavedChanges',
                            text: _.get(this.translations, 'unsavedChanges')
                        };

                        if (sectionTemplateEditorModel.isValidToSave(parseInt($stateParams.sectionTemplateId))) {
                            action.enabled = true;
                        }
                    }
                }

                if (action.name === sectionTemplateAction.DISCARD) {
                    action.enabled = sectionTemplateEditorModel.hasUnsavedPropertiesChanges($stateParams.sectionTemplateId) ||
                        sectionTemplateEditorModel.hasUnsavedRuleChanges($stateParams.sectionTemplateId) || $stateParams.sectionTemplateId === '-1';
                }
            });
        });

        this.actionsTimeLastModified = new Date().getTime();
    };

    this.handleAction = function (action, file) {
        if (action.enabled) {
            switch (action.name) {
                case sectionTemplateAction.SAVE:
                    // Scenario 1: If the section template is conditional
                    if (this.sectionTemplate.applicability === sectionTemplateApplicabilityType.CONDITIONAL) {
                        /*  a.If the triggerRule rule is present i.e existing sectional template, then validate the rule, save it if there are no errors
                            b.If errors and the opened tab is 'rules' then simply show the pop-up to correct the rule before saving and don't save it.
                            c.If errors and the opened tab is 'properties', then simply show the pop-up that the rule has errors and save the template.*/
                        if(!_.isNil(this.sectionTemplate.triggerRule)){
                            configurationMediator.validateRule(this.sectionTemplate.triggerRule).then((result) => {
                                if(sectionTemplateEditorModel.hasUnsavedPropertiesChanges(this.sectionTemplate.id) || _.isEmpty(result.errors)){
                                    var summary = sectionTemplateEditorModel.hasUnsavedPropertiesChanges(this.sectionTemplate.id) ? 'invalidRule.saveSummary' :'invalidRule.summary';
                                    sectionTemplateActionsUtil.saveSectionTemplate(this.translations, this.sectionTemplate).then(()  => {
                                        $state.reload();
                                        if (!_.isEmpty(result.errors)) {
                                            this.openGenericConfirm(_.get(this.translations, 'invalidRule.title'), _.get(this.translations, summary), _.get(this.translations, 'invalidRule.confirmButton'));
                                        }
                                    });
                                } else if(!_.isEmpty(result.errors)){
                                    this.openGenericConfirm(_.get(this.translations, 'invalidRule.title'), _.get(this.translations,'invalidRule.summary'), _.get(this.translations, 'invalidRule.confirmButton'));
                                }
                            });
                        // If the triggerRule rule is not present i.e new sectional template, then save the section template and show a pop-up window to correct the rule.
                        } else{
                            sectionTemplateActionsUtil.saveSectionTemplate(this.translations, this.sectionTemplate).then(()  => {
                                $state.reload();
                                this.openGenericConfirm(_.get(this.translations, 'invalidRule.title'), _.get(this.translations,'invalidRule.saveSummary'), _.get(this.translations, 'invalidRule.confirmButton'));
                            });
                        }
                    // Scenario 2: Simply save the sectional template if it is not conditional
                    } else {
                        sectionTemplateActionsUtil.saveSectionTemplate(this.translations, this.sectionTemplate).then(function () {
                            $state.reload();
                        });
                    }
                    break;

                case sectionTemplateAction.DISCARD:
                    sectionTemplateActionsUtil.discard(this.translations);
                    break;

                case sectionTemplateAction.DELETE:
                    sectionTemplateActionsUtil.delete(this.translations, this.sectionTemplate.id);
                    break;

                case sectionTemplateAction.MARK_IN_PRODUCTION:
                    sectionTemplateActionsUtil.markInProduction(this.translations, this.sectionTemplate.id);
                    break;

                case sectionTemplateAction.RELOAD_SECTION_RULES:
                    configurationActionsUtil.reloadSectionTemplateRules();
                    break;

                default:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;
            }
        }
    };

    $scope.$on(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, (event, sectionTemplateId) => {
        if (parseInt($stateParams.sectionTemplateId) === sectionTemplateId) {
            this.sectionTemplate = sectionTemplateEditorModel.getSectionTemplate(sectionTemplateId);
            this.processActions(this.actions);
        }
    });

    $scope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
        const isCurrentStateSectionTemplateEditor = _.startsWith(fromState.name, 'configuration.sectionTemplateEditor'),
            isTargetSameAsCurrent = toState.name === fromState.name,
            sectionTemplateId = toParams.sectionTemplateId ? parseInt(toParams.sectionTemplateId) : parseInt($stateParams.sectionTemplateId),
            hasUnsavedPropertiesChanges = sectionTemplateEditorModel.hasUnsavedPropertiesChanges(sectionTemplateId),
            hasUnsavedRuleChanges = sectionTemplateEditorModel.hasUnsavedRuleChanges(sectionTemplateId);

        if (toState.name === 'login') {
            return;
        }

        if ((hasUnsavedPropertiesChanges || hasUnsavedRuleChanges) && isCurrentStateSectionTemplateEditor && !isTargetSameAsCurrent) {
            event.preventDefault();
            // Scenario 1: User is navigating away from properties tab
            if (sectionTemplateEditorModel.isValidToSave(sectionTemplateId) && fromState.url === '/properties') {
                // Save the section template and subsequently check for rule validation if it is a conditional section template
                sectionTemplateActionsUtil.saveSectionTemplate(this.translations, this.sectionTemplate).then((sectionTemplate) => {
                    $state.go(toState, {sectionTemplateId: sectionTemplate.id + ''});
                if(sectionTemplate.applicability === sectionTemplateApplicabilityType.CONDITIONAL){
                    configurationMediator.validateRule(sectionTemplate.triggerRule).then((result) => {
                        if (!_.isEmpty(result.errors)) {
                        this.openGenericConfirm(_.get(this.translations, 'invalidRule.title'), _.get(this.translations,'invalidRule.saveSummary'), _.get(this.translations, 'invalidRule.confirmButton'));
                        }
                    });
                }
            });
             // Scenario 2: User is navigating away from Rules tab
            } else if (!_.isNil(this.sectionTemplate.triggerRule) && fromState.url ==='/rule') {
                configurationMediator.validateRule(this.sectionTemplate.triggerRule).then((result) => {
                    if (!_.isEmpty(result.errors)) {
                    this.openGenericConfirm(_.get(this.translations, 'invalidRule.title'), _.get(this.translations,'invalidRule.summary'), _.get(this.translations, 'invalidRule.confirmButton'));
                    }
                });
            }  else {
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'invalidSectionTemplate'));
            }
        } else {
            // there are no changes to be saved, do nothing
        }
    });

    this.openGenericConfirm = function (title, summary, confirmActionButtonLabel) {
        modalUtil.showGenericConfirm({
            title: title,
            summary: summary,
            confirmActionButtonLabel: confirmActionButtonLabel
        });
    }
};

angular.module('ums.configuration')
    .controller('sectionTemplateEditorHeaderController', SectionTemplateEditorHeaderController);
